// ─── Sélecteur mois / année (modale) — porté MoPCal ──────────────
// Ouvert en touchant le titre du calendrier. Grille de 12 mois + navigation
// d'année + « Aujourd'hui ». onChoisir(annee, mois0).
import React, { useMemo, useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, Modal, StyleSheet } from 'react-native';
import { useUI, HIT, useT } from '@mop/core';


export default function SelecteurMoisAnnee({ visible, an, mo, onChoisir, onFermer }) {
  const UI = useUI();
  const t = useT();
  const MOIS_COURT = t('commun.moisCourts');
  const s = useMemo(() => makeStyles(UI), [UI]);
  const [annee, setAnnee] = useState(an);
  useEffect(() => { if (visible) setAnnee(an); }, [visible, an]);
  const auj = new Date();

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onFermer}>
      <TouchableOpacity style={s.backdrop} activeOpacity={1} onPress={onFermer}>
        <TouchableOpacity style={s.card} activeOpacity={1} onPress={() => {}}>
          <View style={s.barre}>
            <TouchableOpacity onPress={() => setAnnee(a => a - 1)} hitSlop={HIT}><Text style={s.nav}>‹</Text></TouchableOpacity>
            <Text style={s.annee}>{annee}</Text>
            <TouchableOpacity onPress={() => setAnnee(a => a + 1)} hitSlop={HIT}><Text style={s.nav}>›</Text></TouchableOpacity>
          </View>
          <View style={s.grille}>
            {MOIS_COURT.map((m, i) => {
              const sel = i === mo && annee === an;
              const estAuj = i === auj.getMonth() && annee === auj.getFullYear();
              return (
                <TouchableOpacity key={i} style={[s.mois, sel && s.moisSel, !sel && estAuj && s.moisAuj]}
                  onPress={() => { onChoisir?.(annee, i); onFermer?.(); }}>
                  <Text style={[s.moisTxt, sel && s.moisTxtSel, !sel && estAuj && s.moisTxtAuj]}>{m}</Text>
                </TouchableOpacity>
              );
            })}
          </View>
          <TouchableOpacity style={s.auj} onPress={() => { onChoisir?.(auj.getFullYear(), auj.getMonth(), auj.getDate()); onFermer?.(); }}>
            <Text style={s.aujTxt}>{t('historique.aujourdhui')}</Text>
          </TouchableOpacity>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
}


const makeStyles = (UI) => StyleSheet.create({
  backdrop: { flex: 1, backgroundColor: UI.overlay, alignItems: 'center', justifyContent: 'center', padding: 24 },
  card: { width: '100%', maxWidth: 340, backgroundColor: UI.card, borderRadius: 16, borderWidth: 0.5, borderColor: UI.border, padding: 14 },
  barre: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingHorizontal: 8, paddingBottom: 10 },
  nav: { fontSize: 26, color: UI.accent, fontWeight: '300', width: 40, textAlign: 'center' },
  annee: { fontSize: 18, fontWeight: '800', color: UI.ink },
  grille: { flexDirection: 'row', flexWrap: 'wrap' },
  mois: { width: `${100 / 3}%`, paddingVertical: 12, alignItems: 'center', borderRadius: 10 },
  moisSel: { backgroundColor: UI.accent },
  moisAuj: { borderWidth: 1.5, borderColor: UI.accent },
  moisTxt: { fontSize: 14.5, fontWeight: '700', color: UI.ink },
  moisTxtSel: { color: '#fff', fontWeight: '800' },
  moisTxtAuj: { color: UI.accent },
  auj: { marginTop: 8, alignItems: 'center', paddingVertical: 10, borderTopWidth: 0.5, borderTopColor: UI.border },
  aujTxt: { fontSize: 14, fontWeight: '800', color: UI.accent },
});
